<template lang="pug">
  div.body.body-table.garbage-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent="letSearch")
              // input(type="search" placeholder="" v-model="searchModel")
            div.parameters
              e-select-year(
                v-if="operationType != 'product'"
                year="year"
              )
            div(v-if="!editDisabled").actions-panel
              e-button-add(@click.prevent.stop="addNewRowToGarbageTable")
              // button(type="button" @click="addNewRowToGarbageTable").actions-panel__button.btn-add.green

      div(v-if="operationType === 'detail'")
          e-table-editable(
              ref="detail"
              :attributes="garbageDetailAttr"
              :dataUrl="garbageDataUrl"
              :postUrl="garbagePostUrl"
              :patchUrl="garbagePatchUrl"
              :deleteUrl="garbageDeleteUrl"
              :enableOnAdd="enableOnAdd"
              :tableInOnlineMode="tableInOnlineMode"
              :afterFetchData="afterFetchData"
              :afterValidate="afterValidate"
              :enabledActions="enabledActions"
          )

      div(v-if="operationType === 'input'")
          e-table-editable(
          ref="input"
            :attributes="garbageInputAttr"
              :dataUrl="garbageDataUrl"
              :postUrl="garbagePostUrl"
              :patchUrl="garbagePatchUrl"
              :deleteUrl="garbageDeleteUrl"
              :enableOnAdd="enableOnAdd"
              :tableInOnlineMode="tableInOnlineMode"
              :afterFetchData="afterFetchData"
              :afterValidate="afterValidate"
              :enabledActions="enabledActions"
          )

      div(v-if="operationType === 'output'")
          e-table-editable(
          ref="output"
            :attributes="garbageOutputAttr"
              :dataUrl="garbageDataUrl"
              :postUrl="garbagePostUrl"
              :patchUrl="garbagePatchUrl"
              :deleteUrl="garbageDeleteUrl"
              :enableOnAdd="enableOnAdd"
              :tableInOnlineMode="tableInOnlineMode"
              :afterFetchData="afterFetchData"
              :afterValidate="afterValidate"
              :enabledActions="enabledActions"
          )

      div(v-if="operationType === 'product'")
        e-table-editable(
        ref="inputProduct"
        :attributes="garbageInputProductAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :afterValidate="afterValidate"
        :enabledActions="enabledActions"
        )
</template>

<script>
  import registryObjectGarbageTableMixin from '../../components/mixins/registry-object-garbage-table-mixin'

  export default {
    name: 'r-registry-object-garbage-table',
    mixins: [registryObjectGarbageTableMixin],
    computed: {
      selectListOptions () {
        let menuItems = [
          {
            id: 'detail',
            name: 'Движение отходов'
          },
          {
            id: 'input',
            name: 'Сведения о полученных отходах'
          }
        ]
        if (this.showInputProduct) {
          menuItems.push({
            id: 'product',
            name: 'Полученная продукция'
          })
        }
        return menuItems
      }
    }
  }
</script>
